import "./menu";
import "./slider";
import "../sass/index.scss";
